import React from 'react';

function InteractiveButtons({ onThemeToggle, onPhotoChange, onShowAlert, isDark }) {
  return (
    <div className="interactive-buttons">
      <button onClick={onThemeToggle} className="theme-btn">
        {isDark ? '☀️' : '🌙'}
      </button>
      <button onClick={onPhotoChange} className="photo-btn">
        📷
      </button>
      <button onClick={onShowAlert} className="alert-btn">
        ℹ️
      </button>
    </div>
  );
}

export default InteractiveButtons;